import React from 'react';

type Props = {
  delay?: number;
  children: React.ReactElement | ((active: boolean) => JSX.Element) | React.ReactNode;
  fallback?: JSX.Element;
};

/**
 * Delays the rendering of a component.
 *
 * This is used e.g. in the invoiceBrowser,
 * to avoid showing the spinner for only fraction of a second.
 */

const DelayRender = ({ delay = 1500, children, fallback }: Props): JSX.Element | null => {
  const [timerExpired, setTimerExpired] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setTimerExpired(true);
    }, delay);
    return () => clearTimeout(timer);
  }, [delay]);

  if (typeof children === 'function') {
    return children(timerExpired);
  }

  if (!timerExpired) {
    return fallback ?? null;
  }

  return <>{children}</>;
};

export default DelayRender;
